/**
 * Olumsuz oy neden etiketleri — admin tarafının KENDİ kopyası (ChatWidget'a çalışma zamanı bağımlılığı yok).
 * Kodlar, sıra ve Türkçe metinler `ChatWidget/messageFeedback.FEEDBACK_REASONS` ile birebir aynıdır;
 * `feedbackReportContract.test.tsx` iki listenin eşitliğini kilitler (spec §7.4).
 */
export const ADMIN_FEEDBACK_REASONS: { code: string; label: string }[] = [
  { code: 'misunderstood', label: 'Sorumu yanlış anladı' },
  { code: 'incomplete', label: 'Bilgi eksikti' },
  { code: 'incorrect', label: 'Bilgi yanlıştı' },
  { code: 'slow', label: 'Çok yavaştı' },
  { code: 'other', label: 'Diğer' },
]

/** `ReasonCode = null`: bayi neden seçmeden yalnız 👎 verdi (veya yalnız yorum yazdı). */
export const NO_REASON_LABEL = 'Neden seçilmedi'

/** Bilinmeyen kod SESSİZCE DÜŞÜRÜLMEZ: ham kod gösterilir (sunucu kümesi büyürse fark edilir). */
export const adminFeedbackReasonLabel = (code: string | null): string => {
  if (!code) return NO_REASON_LABEL
  return ADMIN_FEEDBACK_REASONS.find(reason => reason.code === code)?.label ?? code
}

/** Kartlar sabit sırada: bilinen nedenler liste sırasıyla, bilinmeyenler sonra, "Neden seçilmedi" en sonda. */
export const reasonSortIndex = (code: string | null): number => {
  if (!code) return Number.MAX_SAFE_INTEGER
  const index = ADMIN_FEEDBACK_REASONS.findIndex(reason => reason.code === code)
  return index === -1 ? ADMIN_FEEDBACK_REASONS.length : index
}
